import { render, staticRenderFns } from "./ion-switch.vue?vue&type=template&id=3adb7af6"
import script from "./ion-switch.vue?vue&type=script&lang=js"
export * from "./ion-switch.vue?vue&type=script&lang=js"
import style0 from "./ion-switch.vue?vue&type=style&index=0&id=3adb7af6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports